/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Channel_LocationInputs */

const en_contact_channel_location = /** @type {(inputs: Contact_Channel_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Based in`)
};

const lv_contact_channel_location = /** @type {(inputs: Contact_Channel_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atrodamies`)
};

/**
* | output |
* | --- |
* | "Based in" |
*
* @param {Contact_Channel_LocationInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_channel_location = /** @type {((inputs?: Contact_Channel_LocationInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Channel_LocationInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_channel_location(inputs)
	return en_contact_channel_location(inputs)
});